import React from 'react';
import { string } from 'prop-types';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ScreeningDetail from '../pages/_screening_id/ScreeningDetail';
export default function AppRoutes(_ref) {
  var basename = _ref.basename;
  return /*#__PURE__*/React.createElement(BrowserRouter, {
    basename: basename
  }, /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    path: "facesheet/:contact_id/submission/:screening_id",
    element: /*#__PURE__*/React.createElement(ScreeningDetail, null)
  })));
}
AppRoutes.propTypes = {
  basename: string.isRequired
};
//# sourceMappingURL=AppRoutes.js.map